import React, { useEffect, useState } from "react";
import axios from "axios";
import TableLoader from "Components/Common/Loader/TableLoader";
import Pagination from "Components/Pagination/Pagination";


const REPORT_TYPES = [
  "Asking personal details",
  "Harassment",
  "Asking money",
  "Fake / Misleading Profile",
  "Hate Speech",
];

const TABS = [
  { label: "Audio Call", value: "Audio Call" },
  { label: "Video Call", value: "Video Call" },
  { label: "Group Call", value: "Group Call" },
];

const LIMIT = 10;

const ReportUsers = () => {
  const [activeTab, setActiveTab] = useState("Audio Call");
  const [selectedReportType, setSelectedReportType] = useState("");
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [error, setError] = useState(""); // <-- Error state

  const fetchReports = async () => {
    setLoading(true);
    setError(""); // reset previous errors
    try {
      const params = { page, limit: LIMIT };
      if (activeTab) params.callType = activeTab;
      if (selectedReportType) params.reportType = selectedReportType;

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/report/get-all`,
        { params }
      );

      // Check backend response structure
      if (res.status !== 200 || !res.data.reports) {
        throw new Error(res.data?.message || "Failed to fetch reports");
      }

      setReports(res.data.reports);
      setTotalPages(res.data.totalPages || 1);
    } catch (err) {
      console.error(err);

      
      if (err.response && err.response.data?.message) {
        setError(err.response.data.message);
      } else if (err.message) {
        setError(err.message); 
      } else {
        setError("Something went wrong while fetching reports");
      }

      setReports([]); 
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPage(1); // reset page on filter change
  }, [activeTab, selectedReportType]);

  useEffect(() => {
    fetchReports();
  }, [activeTab, selectedReportType, page]);

  return (
    <>
      <div className="mt-0 flex flex-col gap-4 bg-white p-8 shadow-sm">
        {/* Tabs + Dropdown */}
        <div className="flex flex-wrap items-center justify-start gap-4">
          <div className="flex gap-4">
            {TABS.map((tab) => (
              <button
                key={tab.value}
                onClick={() => {
                  setSelectedReportType("");
                  setActiveTab(tab.value);
                }}
                className={`rounded-lg px-4 py-2 ${
                  activeTab === tab.value
                    ? "bg-[#c51369] text-white"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div>
            <select
              value={selectedReportType}
              onChange={(e) => {
                setActiveTab(""); 
                setSelectedReportType(e.target.value);
              }}
              className="rounded-lg border px-3 py-2"
            >
              <option value="">Report Types</option>
              {REPORT_TYPES.map((type, i) => (
                <option key={i} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Show error if exists */}
      {error && (
        <p className="p-4 text-center text-red-600 font-semibold">{error}</p>
      )}

      {/* Table */}
      {loading ? (
        <TableLoader />
      ) : reports.length === 0 && !error ? (
        <p className="p-4 text-center text-gray-500">No reports found</p>
      ) : (
        <div className="overflow-x-auto mt-4 pt-2">
          <table className="w-full border-collapse border border-gray-300">
            <thead className="text-md bg-[#e0ced7] uppercase tracking-wide text-navy-900 ">
              <tr className="text-sm ">
                <th className="border p-4">Sl. No.</th>
                <th className="border p-4">Date & Time</th>
                <th className="border p-4">Reported User</th>
                <th className="border p-4">Reported By</th>
                <th className="border p-4">Report Type</th>
                <th className="border p-4">Reason</th>
                <th className="border p-4">Action</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((r, index) => (
                <tr key={r._id} className="text-center text-md bg-white tracking-wide text-gray-700">
                  <td className="border p-2">{(page - 1) * LIMIT + index + 1}</td>
                  <td className="border p-2">
                    <div className="flex flex-col">
                      <span className="text-sm">{new Date(r.createdAt).toLocaleDateString()}</span>
                      <span className="text-sm text-gray-500">
                        {new Date(r.createdAt).toLocaleTimeString()}
                      </span>
                    </div>
                  </td>
                  <td className="border p-2">{r.userId?.nickName || r.userId?.phone}</td>
                  <td className="border p-2">{r.reportedBy?.nickName || r.reportedBy?.phone}</td>
                  <td className="border p-2">{r.reportType}</td>
                  <td className="border p-2">{r.reason}</td>
                  <td className="border p-2">
                    <button className="rounded bg-red-500 px-3 py-1 text-white">Action</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          {reports.length > 0 && (
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={setPage}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ReportUsers;
